<template>
  <div>
    <section>
      <template>
        <v-container fluid>
          <v-row justify="center" align="center">
            <v-col cols="12">
              <div class="mt-3">
                <v-row class="match-height">
                  <!-- Mobile: Single card with both sections -->
                  <v-col cols="12" class="hidden-md-and-up">
                    <v-skeleton-loader
                      v-if="helpers.dataIsLoading"
                      elevation="2"
                      type="article"
                    ></v-skeleton-loader>
                    <v-card v-else>
                      <v-card-title class="body-2 v-card__subtitle">
                        <v-icon x-small class="mr-2">mdi-counter</v-icon
                        >Zusammenfassung der Rückmeldungen
                      </v-card-title>
                      <v-card-text>
                        <response-statistics-card
                          marginClass="mr-2 mb-2"
                          :totalConfirmations="getStatusCount('1')"
                          :totalAccepted="getAcceptionsCount()"
                          :totalIfNecessary="getStatusCount('3')"
                          :totalCancellations="getStatusCount('2')"
                          :totalNotInTown="getStatusCount('4')"
                          :totalAwaitingResponse="getStatusCount('0')"
                          :totalResponses="getStatusCount('all')"
                        ></response-statistics-card>
                      </v-card-text>
                      <v-divider></v-divider>
                      <v-card-title class="body-2 v-card__subtitle">
                        <v-icon x-small class="mr-2">mdi-tag</v-icon>
                        <span>Verfügbare Funktionen</span>
                        <span
                          v-show="countersCalculationMode === 'highest'"
                          class="hidden-md-and-up"
                          >&nbsp;(Höchste)</span
                        >
                        <span
                          v-show="countersCalculationMode === 'all'"
                          class="hidden-md-and-up"
                          >&nbsp;(Einzeln)</span
                        >
                        <v-spacer></v-spacer>
                        <v-btn-toggle
                          v-model="countersCalculationMode"
                          mandatory
                          dense
                          :class="$vuetify.breakpoint.smAndDown ? 'mt-2' : ''"
                        >
                          <v-btn small value="highest">
                            <v-icon :left="!$vuetify.breakpoint.smAndDown" small
                              >mdi-chevron-triple-up</v-icon
                            >
                            <span class="hidden-sm-and-down">Höchste</span>
                          </v-btn>
                          <v-btn small value="all">
                            <v-icon :left="!$vuetify.breakpoint.smAndDown" small
                              >mdi-all-inclusive</v-icon
                            >
                            <span class="hidden-sm-and-down">Einzeln</span>
                          </v-btn>
                        </v-btn-toggle>
                      </v-card-title>
                      <v-card-text>
                        <position-counters-card
                          :positionCounters="schedulingConfig.positionCounters"
                          :availablePersonnel="eventResponsesMatched"
                          :calculationMode="countersCalculationMode"
                        ></position-counters-card>
                      </v-card-text>
                      <v-divider v-if="checkIfSupport"></v-divider>
                      <v-card-title
                        v-if="checkIfSupport"
                        class="body-2 v-card__subtitle"
                        ><v-icon x-small class="mr-2">mdi-tools</v-icon
                        >Rückmeldungen in Datensatz
                      </v-card-title>
                      <v-card-text v-if="checkIfSupport">
                        <response-statistics-card
                          marginClass="mr-2"
                          :totalConfirmations="event.count.totalConfirmations"
                          :totalIfNecessary="event.count.totalIfNecessary"
                          :totalCancellations="event.count.totalCancellations"
                          :totalNotInTown="event.count.totalAway"
                          :totalResponses="event.count.totalResponses"
                          useV2Style
                        ></response-statistics-card>
                      </v-card-text>
                    </v-card>
                  </v-col>

                  <!-- Desktop: Response statistics card -->
                  <v-col cols="12" md="6" class="hidden-sm-and-down">
                    <v-skeleton-loader
                      v-if="helpers.dataIsLoading"
                      elevation="2"
                      type="article"
                    ></v-skeleton-loader>
                    <v-card v-else>
                      <v-card-title class="body-2 v-card__subtitle">
                        <v-icon x-small class="mr-2">mdi-counter</v-icon
                        >Zusammenfassung der Rückmeldungen
                      </v-card-title>
                      <v-card-text>
                        <response-statistics-card
                          marginClass="mr-2 mb-2"
                          :totalConfirmations="getStatusCount('1')"
                          :totalAccepted="getAcceptionsCount()"
                          :totalIfNecessary="getStatusCount('3')"
                          :totalCancellations="getStatusCount('2')"
                          :totalNotInTown="getStatusCount('4')"
                          :totalAwaitingResponse="getStatusCount('0')"
                          :totalResponses="getStatusCount('all')"
                        ></response-statistics-card>
                      </v-card-text>
                      <v-divider v-if="checkIfSupport"></v-divider>
                      <v-card-title
                        v-if="checkIfSupport"
                        class="body-2 v-card__subtitle"
                        ><v-icon x-small class="mr-2">mdi-tools</v-icon
                        >Rückmeldungen in Datensatz
                      </v-card-title>
                      <v-card-text v-if="checkIfSupport">
                        <response-statistics-card
                          marginClass="mr-2"
                          :totalConfirmations="event.count.totalConfirmations"
                          :totalIfNecessary="event.count.totalIfNecessary"
                          :totalCancellations="event.count.totalCancellations"
                          :totalNotInTown="event.count.totalAway"
                          :totalResponses="event.count.totalResponses"
                          useV2Style
                        ></response-statistics-card>
                      </v-card-text>
                    </v-card>
                  </v-col>

                  <!-- Desktop: Position counters card -->
                  <v-col cols="12" md="6" class="hidden-sm-and-down">
                    <v-skeleton-loader
                      v-if="helpers.dataIsLoading"
                      elevation="2"
                      type="article"
                    ></v-skeleton-loader>
                    <v-card v-else>
                      <v-card-title class="body-2 v-card__subtitle">
                        <v-icon x-small class="mr-2">mdi-tag</v-icon>
                        <span>Verfügbare Funktionen</span>
                        <v-spacer></v-spacer>
                        <v-btn-toggle
                          v-model="countersCalculationMode"
                          mandatory
                          dense
                        >
                          <v-btn small value="highest">
                            <v-icon :left="!$vuetify.breakpoint.smAndDown" small
                              >mdi-chevron-triple-up</v-icon
                            >
                            <span class="hidden-sm-and-down">Höchste</span>
                          </v-btn>
                          <v-btn small value="all">
                            <v-icon :left="!$vuetify.breakpoint.smAndDown" small
                              >mdi-all-inclusive</v-icon
                            >
                            <span class="hidden-sm-and-down">Einzeln</span>
                          </v-btn>
                        </v-btn-toggle>
                      </v-card-title>
                      <v-card-text>
                        <position-counters-card
                          :positionCounters="schedulingConfig.positionCounters"
                          :availablePersonnel="eventResponsesMatched"
                          :calculationMode="countersCalculationMode"
                        ></position-counters-card>
                      </v-card-text>
                    </v-card>
                  </v-col>

                  <v-col cols="12" sm="12" md="12">
                    <v-skeleton-loader
                      v-if="helpers.dataIsLoading"
                      elevation="2"
                      type="table-heading, table-thead, table-tbody"
                    ></v-skeleton-loader>
                    <v-card v-else>
                      <event-responses-data-table
                        :eventResponses="eventResponsesMatched"
                        :showPerformanceTargets="canViewPerformanceTargets"
                        mode="view"
                        @open-performance-target-details="
                          openPerformanceTargetDetails
                        "
                      ></event-responses-data-table>
                    </v-card>
                  </v-col>
                </v-row>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </template>
    </section>
    <section v-if="checkIfSupport">
      <support-tools :sources="code"></support-tools>
    </section>
    <!-- Performance Target Details Dialog -->
    <custom-dialog
      v-if="helpers.performanceTargetDialog.model"
      @close="closePerformanceTargetDialog"
      width="l"
      title="Berechnungsdetails"
      fullscreenOnMobile
      hideActionBtn
      showCloseBtn
    >
      <template v-slot:content>
        <performance-target-results-details-dialog
          v-if="helpers.performanceTargetDialog.selectedUser"
          :userData="getPerformanceTargetUserData"
        ></performance-target-results-details-dialog>
      </template>
    </custom-dialog>
    <v-snackbar
      v-model="helpers.snackbar.isVisible"
      class="pb-4"
      bottom
      app
      timeout="3000"
      ><v-icon color="success" class="mr-1">mdi-check-circle</v-icon>
      {{ helpers.snackbar.message }}
    </v-snackbar>
  </div>
</template>

<script>
import { db } from "@/firebase";
import SupportTools from "@/components/_system/helpers/SupportTools.vue";
import CustomDialog from "@/components/_systemwide/CustomDialog.vue";
import ResponseStatisticsCard from "@/components/scheduling/ResponseStatisticsCard.vue";
import EventResponsesDataTable from "@/components/scheduling/EventResponsesDataTable.vue";
import PositionCountersCard from "@/components/scheduling/PositionCountersCard.vue";
import PerformanceTargetResultsDetailsDialog from "@/components/member-management/performance-targets/PerformanceTargetResultsDetailsDialog.vue";
import { ADMIN, MEMBER_MANAGEMENT } from "@/store/modules.js";
import {
  GET_USER_LIST,
  GET_PERFORMANCE_TARGET_RESULTS,
} from "@/store/action-types.js";
import { MEMBER_MANAGEMENT_PERFORMANCE_TARGETS_ALL_read } from "@/data/permission-types.js";

export default {
  name: "scheduling-event-details-tab-responses",
  components: {
    SupportTools,
    CustomDialog,
    EventResponsesDataTable,
    ResponseStatisticsCard,
    PositionCountersCard,
    PerformanceTargetResultsDetailsDialog,
  },
  props: {
    event: Object,
  },
  data() {
    return {
      data: { meta: { status: "" } },

      helpers: {
        dataIsLoading: true,

        snackbar: {
          isVisible: false,
          message: "",
        },

        performanceTargetDialog: {
          model: false,
          selectedUser: null,
        },
      },

      eventResponses: [],
      status: ["1", "3", "2", "4", "0"],
      countersCalculationMode: "highest",
      userResponse: {
        user: {
          uid: null,
        },
        status: { id: null },
        comment: null,
        type: "regular",
        assignedTasks: [],
        assignedPosition: {
          custom: {
            text: "",
          },
          unit: {
            id: "",
            title: "",
          },
          position: {
            id: "",
            shortTitle: "",
          },
          comboId: "",
        },
        isCanceled: false,
        guests: { count: 0 },
      },
    };
  },
  computed: {
    code() {
      return [
        { title: "event", data: this.event },
        { title: "eventResponses", data: this.eventResponses },
        { title: "memberships", data: this.memberships },
        { title: "membershipsPrepared", data: this.membershipsPrepared },
        { title: "eventResponsesMatched", data: this.eventResponsesMatched },
        {
          title: "countDifference",
          data: [this.memberships.length, this.membershipsPrepared.length],
        },
        {
          title: "membershipsPreparedDisplayName",
          data: this.membershipsPrepared.map((a) => a.user.displayName),
        },
      ];
    },
    schedulingConfig() {
      return this.$store.state.organization.activeOrganization.config
        .scheduling;
    },
    memberships() {
      return this.$store.state.admin.membershipsPublic;
    },
    membershipsPrepared() {
      var range = {
        start: this.event.duration.start.timestampToDate,
        end: this.event.duration.end.timestampToDate,
      };
      var membershipsFiltered = this.memberships.filter((obj) => {
        return (
          new Date(obj.user.memberSinceToDate) <= new Date(range.start) && // All members that where members before or at the start of this event
          !(new Date(obj.user.memberUntilToDate) <= new Date(range.end)) && // All members that didn't leave before or at the event of this event
          obj.access.type === "member"
        );
      });

      var memberships = membershipsFiltered;
      // if (this.event.status !== "planned") {}
      const result = memberships.map((item) => {
        const container = {
          groupByGroup:
            item.group.sortKey.toString().padStart(4, "0") +
            "_" +
            item.group.title,
          groupByDivision:
            item.user.division.sortKey.toString().padStart(4, "0") +
            "_" +
            item.user.division.title,
          group: {
            title: item.group.title,
            sortKey: item.group.sortKey,
            id: item.group.id,
          },
          user: {
            displayName: item.user.displayName,
            uid: item.user.uid,
            // photoURL = item.user.photoURL,
            division: {
              title: item.user.division.title,
              shortTitle: item.user.division.shortTitle,
              sortKey: item.user.division.sortKey,
              id: item.user.division.id,
            },
            fillablePositions: item.fillablePositions,
            relevantSkills: item.relevantSkills,
          },
        };
        return container;
      });
      return result;
    },

    eventResponsesMatched() {
      const memberships = this.membershipsPrepared;
      // 1: Match memberships to event status
      // const matched = this.eventResponses.map((response) => {
      //   const matchedMembership = memberships.find(
      //     (membership) => membership.user.uid === response.meta.uid
      //   );
      //   return { ...response, ...matchedMembership };
      // });
      const matched = this.eventResponses
        .map((response) => {
          const matchedMembership = memberships.find(
            (membership) => membership.user.uid === response.meta.uid
          );
          // Check if matchedMembership is not undefined before merging
          if (matchedMembership) {
            return { ...response, ...matchedMembership };
          }
          // If matchedMembership is undefined, return null
          return null;
        })
        // Filter out any null values from the array
        .filter((item) => item !== null);

      // 2: Find missing memberships
      const missing = memberships.filter((o) =>
        matched.every((s) => s.user.uid !== o.user.uid)
      );

      // 3: Create event status for missing memberships
      var addedStatus = [];
      if (missing.length > 0) {
        addedStatus = missing.map((obj) => ({
          ...obj,
          comment: "",
          type: "regular",
          isCanceled: false,
          meta: {
            uid: obj.user.uid,
            lastUpdatedBy: "",
          },
          groupByStatus: "5_Keine Rückmeldung",
          status: {
            id: "0",
          },
          assignedTasks: [],
          assignedPosition: {
            custom: {
              text: "",
            },
            unit: {
              id: "",
              title: "",
            },
            position: {
              id: "",
              shortTitle: "",
            },
            comboId: "",
          },
          guests: {
            count: 0,
          },
        }));
      }

      // 4: Combine both groups as output
      let output = matched.concat(addedStatus);

      // 5: Delete items with user.uid,  group.id or division.id not in allowedAttendeesIds, excluding items with status.id !== "0"
      if (this.event.config.attendance.isLimited) {
        const allowedAttendeesIds =
          this.event.config.attendance.allowedAttendeesIds;
        output = output.filter((obj) => {
          return (
            allowedAttendeesIds.includes(obj.user.uid) ||
            allowedAttendeesIds.includes(obj.group.id) ||
            allowedAttendeesIds.includes(obj.user.division.id) ||
            obj.status.id !== "0"
          );
        });
      }

      // 6: Merge performance target traffic light status if user has permission
      if (this.canViewPerformanceTargets && this.performanceTargetResults) {
        output = output.map((item) => {
          const performanceResult = this.performanceTargetResults.find(
            (result) => result.user.uid === item.user.uid
          );
          const trafficLightStatus = performanceResult
            ? performanceResult.trafficLightStatus
            : "unknown";

          // Sort order: green -> yellow -> red -> unknown
          const trafficLightSortKey =
            trafficLightStatus === "green"
              ? "1"
              : trafficLightStatus === "yellow"
              ? "2"
              : trafficLightStatus === "red"
              ? "3"
              : "4";

          const trafficLightText =
            trafficLightStatus === "green"
              ? "Grüne Ampel"
              : trafficLightStatus === "yellow"
              ? "Gelbe Ampel"
              : trafficLightStatus === "red"
              ? "Rote Ampel"
              : "Unbekannt";

          return {
            ...item,
            trafficLightStatus,
            groupByPerformanceTarget: `${trafficLightSortKey}_${trafficLightText}`,
          };
        });
      } else {
        // Add default values if user doesn't have permission
        output = output.map((item) => ({
          ...item,
          trafficLightStatus: "unknown",
          groupByPerformanceTarget: "4_Unbekannt",
        }));
      }

      return output;
    },

    checkIfSupport() {
      return this.$store.getters["organization/checkIfSupport"];
    },
    canViewPerformanceTargets() {
      return this.$store.getters["organization/checkPermissionByID"](
        `${MEMBER_MANAGEMENT_PERFORMANCE_TARGETS_ALL_read}`
      );
    },
    performanceTargetResults() {
      return this.$store.state.memberManagement.performanceTargetResults;
    },
    getPerformanceTargetUserData() {
      if (!this.helpers.performanceTargetDialog.selectedUser) {
        return null;
      }
      const selectedUser = this.helpers.performanceTargetDialog.selectedUser;
      const performanceResult = this.performanceTargetResults.find(
        (result) => result.user.uid === selectedUser.user.uid
      );

      if (!performanceResult) {
        return {
          user: selectedUser.user,
          trafficLightStatus: "unknown",
          totalStatus: "unknown",
          performanceTargets: [],
        };
      }

      console.log(performanceResult);
      return {
        user: selectedUser.user,
        trafficLightStatus: performanceResult.trafficLightStatus,
        totalStatus: performanceResult.totalStatus,
        performanceTargets: performanceResult.performanceTargets || [],
        lastCalculatedAt: performanceResult.meta?.lastCalculatedAt || null,
      };
    },
  },
  created() {
    this.initialize();
  },
  watch: {
    $route: "initialize",
    event: function (newValue) {
      this.data = newValue;
      if (newValue !== null) {
        this.getMemberships();
      }
    },
  },
  methods: {
    initialize() {
      db.collection("organizations")
        .doc(this.$route.params.organizationId)
        .collection("events")
        .doc(this.$route.params.itemId)
        .collection("responses")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const data = {
              ...doc.data(),
              groupByStatus:
                this.orderPrefix(doc.data().status.id) +
                "_" +
                this.statusText(doc.data().status.id),
              status: {
                id: doc.data().status.id,
              },
              meta: {
                uid: doc.data().meta.uid,
                lastUpdatedAt: doc.data().meta.lastUpdatedAt,
                lastUpdatedBy: doc.data().meta.lastUpdatedBy,
              },
              // assignedPosition: {
              //   custom: {
              //     text: "",
              //   },
              //   unit: {
              //     id: "",
              //     title: "",
              //   },
              //   position: {
              //     id: "",
              //     shortTitle: "",
              //   },
              //   comboId: "",
              // },
            };

            if (
              data.meta.lastUpdatedBy &&
              data.meta.lastUpdatedBy !== data.meta.uid
            ) {
              data.meta.lastUpdatedByDisplayName = this.getDisplayName(
                data.meta.lastUpdatedBy
              );
            }
            this.eventResponses.push(data);
          });
        })
        .then(() => {
          this.helpers.dataIsLoading = false;
          // Fetch performance target results if user has permission
          if (this.canViewPerformanceTargets) {
            this.$store.dispatch(
              `${MEMBER_MANAGEMENT}${GET_PERFORMANCE_TARGET_RESULTS}`,
              {
                organizationId: this.$route.params.organizationId,
              }
            );
          }
        })
        .catch(function (error) {
          console.log("Error getting document:", error);
          return false;
        });
    },

    getMemberships() {
      if (this.data.status === "planned") {
        this.$store.dispatch(`${ADMIN}${GET_USER_LIST}`, {
          organizationId: this.$route.params.organizationId,
          queryIsFiltered: true,
          query: {
            type: "active",
          },
        });
      } else {
        this.$store.dispatch(`${ADMIN}${GET_USER_LIST}`, {
          organizationId: this.$route.params.organizationId,
          queryIsFiltered: false,
          query: {
            type: "archived",
            memberUntil: this.convertToDate(
              this.event.duration.start.timestamp
            ),
          },
        });
      }
    },
    getDisplayName(uid) {
      if (!uid) return "";
      const user = this.memberships.find(
        (membership) => membership.user && membership.user.uid === uid
      );
      if (!user || !user.user || !user.user.displayName) return "";
      return user.user.displayName;
    },

    openPerformanceTargetDetails(response) {
      this.helpers.performanceTargetDialog.selectedUser = response;
      this.helpers.performanceTargetDialog.model = true;
    },

    closePerformanceTargetDialog() {
      this.helpers.performanceTargetDialog.model = false;
      this.helpers.performanceTargetDialog.selectedUser = null;
    },

    statusText(item) {
      switch (item) {
        case "-1":
          return "Nicht eingeladen";
        case "0":
          return "Keine Rückmeldung";
        case "1":
          return "Verfügbar";
        case "2":
          return "Nicht verfügbar";
        case "3":
          return "Wenn notwendig";
        case "4":
          return "Nicht in Stadt";
        case "":
          return "Fehler";
        default:
          return "";
      }
    },
    orderPrefix(item) {
      switch (item) {
        case "-1":
          return "7";
        case "0":
          return "5";
        case "1":
          return "1";
        case "3":
          return "2";
        case "2":
          return "3";
        case "4":
          return "4";
        case "X":
          return "X";
        default:
          return "";
      }
    },

    getStatusCount(statusId) {
      if (statusId == "all") {
        return (
          this.countStatusById("1") +
          this.countStatusById("2") +
          this.countStatusById("3") +
          this.countStatusById("4")
        );
      } else {
        return this.countStatusById(statusId);
      }
    },
    getAcceptionsCount() {
      var count = this.eventResponsesMatched.reduce(function (n, userResponse) {
        return n + (userResponse.status.id == "1" && userResponse.isAccepted);
      }, 0);
      return count;
    },
    countStatusById(statusId) {
      var count = this.eventResponsesMatched.reduce(function (n, userResponse) {
        return n + (userResponse.status.id == statusId);
      }, 0);
      return count;
    },

    convertToDate(date) {
      date = date.toDate();
      return (
        (date.getDate() < 10 ? "0" : "") +
        date.getDate() +
        "-" +
        (date.getMonth() + 1 < 10 ? "0" : "") +
        (date.getMonth() + 1) +
        "-" +
        date.getFullYear()
      );
    },
  },
};
</script>

<style>
.border-light {
  border-right: thin solid hsla(0, 0%, 100%, 0.12) !important;
}

.border-dark {
  border-right: thin solid rgba(0, 0, 0, 0.12) !important;
}
</style>
